import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function PaymentSuccess() {
    return (
        <Container sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h3" gutterBottom>Payment Successful!</Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
                Your payment has been processed successfully.
            </Typography>
            <Button
                variant="contained"
                component={Link}
                to="/dashboard"
            >
                Return to Dashboard
            </Button>
        </Container>
    );
}